export default {
    template: `
      <div style="display: inline-block">
        <span class="groupTitle">{{ key }}</span>
      </div>
    `,
    data: function () {
        return {
            key: null,
        };
    },
    beforeMount() {
        this.params.api.addEventListener('cellValueChanged', this.updateGui);
        this.params.api.addEventListener('filterChanged', this.updateGui);
        this.updateGui();
    },
    methods: {
        updateGui() {
            this.key = this.params.node.key;
        },
    },
};
